import React from 'react';
import styles from './moderation-pending-cards.module.scss';
import { Typography } from '@/ui-kit';
import { ModerationPendingIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';

interface Props {}

export const ModerationPendingCards: React.FC<Props> = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <ModerationPendingIcon
                    className={styles.remoderationCardIcon}
                    width={56}
                    height={56} />
                <Typography
                    fontWeight="bold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    {t('your_profile_is_being_reviewed')}
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    {t('we_are_currently_checking_your_info')}
                </Typography>
            </div>
        </div>
    );
};
